// Performance, Visibility and Off-court out of 10 (Kobi, 10/15: "out of 10
// instead of 100"). The pillars stay 0 to 100 everywhere they are stored and
// sent (the CacheScore blend, the archetypes, the NIL engine and CacheShare
// read that scale); only the screen reads them out of 10, with one decimal:
// "6.1/10" on a bar or a card, "6.1" in a table whose header says "(out of
// 10)". The CacheScore keeps its 0 to 100 scale. The backend twin is
// scoring_blend.index_of_10.

// The placeholder for a pillar that was never computed: an en dash, never 0.
export const INDEX_EMPTY = "–";

// What a bar or a card puts after the number, and a table header's note.
export const INDEX_SUFFIX = "/10";
export const OUT_OF_10 = "(out of 10)";

// A 0 to 100 pillar out of 10: clamped to 0 to 100, then one decimal (64 is
// 6.4, 61.25 is 6.1, 140 is 10). null for a missing value or anything that is
// not a number, so "never computed" never reads as 0.
export const toIndex10 = (v) => {
  if (v === null || v === undefined || typeof v === "boolean") return null;
  if (typeof v === "string" && !v.trim()) return null;
  const n = typeof v === "number" ? v : Number(v);
  if (!Number.isFinite(n)) return null;
  return Math.round(Math.min(100, Math.max(0, n))) / 10;
};

// "6.1", or "6.1/10" with { suffix: true } (a string suffix is used as
// given); the en dash, without a suffix, for a missing value.
export const fmtIndex10 = (v, { suffix = false } = {}) => {
  const index = toIndex10(v);
  if (index == null) return INDEX_EMPTY;
  const tail = suffix === true ? INDEX_SUFFIX : typeof suffix === "string" ? suffix : "";
  return `${index.toFixed(1)}${tail}`;
};
